import { createSelector } from 'reselect';
import { activeSelector } from 'selectors/testTarget/offers/simplifyPickupBopisHeaderTextPdp/active/activeSelector';
import { isTestTargetReadySelector } from 'viewModel/selectors/testTarget/isTestTargetReadySelector';

const activeSimplifyPickupBopisHeaderTextPdpSelector = createSelector(
    isTestTargetReadySelector,
    activeSelector,
    (testReady, active) => testReady && active
);

export { activeSimplifyPickupBopisHeaderTextPdpSelector };
